export const milesBetween = (a, b) => {
  if (typeof a?.latitude !== 'number' || typeof a?.longitude !== 'number' ||
      typeof b?.latitude !== 'number' || typeof b?.longitude !== 'number') return undefined
  const toRad = (deg) => deg * Math.PI / 180
  const dLat = toRad(b.latitude - a.latitude)
  const dLon = toRad(b.longitude - a.longitude)
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.latitude)) * Math.cos(toRad(b.latitude)) * Math.sin(dLon / 2) ** 2
  return 2 * 3958.8 * Math.asin(Math.sqrt(h))
}
